var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterRedesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.49,140.89S521.7,35.63,388.14,27.5,176.67,105.66,139.76,157.12,10.8,294.32,21.63,372.83,139,510.91,291.47,484.74s196.74-36.1,266.24-16.24,159.73-9.93,161.54-122.74S624.49,140.89,624.49,140.89Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.49,140.89S521.7,35.63,388.14,27.5,176.67,105.66,139.76,157.12,10.8,294.32,21.63,372.83,139,510.91,291.47,484.74s196.74-36.1,266.24-16.24,159.73-9.93,161.54-122.74S624.49,140.89,624.49,140.89Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 52.62,
    y1: 447.26,
    x2: 715.15,
    y2: 447.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.31,
    y: 445.57,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.83,
    y: 445.57,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.73,
    y: 445.57,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.37,
    y: 445.57,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.75,
    y: 445.57,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.33,
    y1: 445.59,
    x2: 537.33,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.72,
    y1: 445.59,
    x2: 543.72,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.1,
    y1: 451.42,
    x2: 550.1,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.1,
    y1: 445.59,
    x2: 550.1,
    y2: 449.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.49,
    y1: 445.59,
    x2: 556.49,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.88,
    y1: 445.59,
    x2: 562.88,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.26,
    y1: 453.64,
    x2: 569.26,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.26,
    y1: 445.59,
    x2: 569.26,
    y2: 450.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.65,
    y1: 445.59,
    x2: 575.65,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.03,
    y1: 445.59,
    x2: 582.03,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.42,
    y1: 452.81,
    x2: 588.42,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.42,
    y1: 445.59,
    x2: 588.42,
    y2: 450.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.81,
    y1: 445.59,
    x2: 594.81,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.19,
    y1: 445.59,
    x2: 601.19,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.58,
    y1: 446,
    x2: 607.58,
    y2: 456.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 613.97,
    y1: 452.17,
    x2: 613.97,
    y2: 456.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 613.97,
    y1: 446,
    x2: 613.97,
    y2: 447.8,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.35,
    y1: 446,
    x2: 620.35,
    y2: 456.29,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.74,
    y1: 446,
    x2: 626.74,
    y2: 456.29,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.13,
    y1: 446,
    x2: 633.13,
    y2: 456.29,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.51,
    y1: 454.2,
    x2: 639.51,
    y2: 456.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.51,
    y1: 446,
    x2: 639.51,
    y2: 450.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.9,
    y1: 446,
    x2: 645.9,
    y2: 456.29,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.29,
    y1: 446,
    x2: 652.29,
    y2: 456.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.96,
    y: 434.6,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.48,
    y: 434.6,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.38,
    y: 434.6,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.03,
    y: 434.6,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.4,
    y: 434.6,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 534.98,
    y1: 434.62,
    x2: 534.98,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541.37,
    y1: 434.62,
    x2: 541.37,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.76,
    y1: 440.45,
    x2: 547.76,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.76,
    y1: 434.62,
    x2: 547.76,
    y2: 438.51,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 554.14,
    y1: 434.62,
    x2: 554.14,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560.53,
    y1: 434.62,
    x2: 560.53,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.92,
    y1: 442.67,
    x2: 566.92,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.92,
    y1: 434.62,
    x2: 566.92,
    y2: 439.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.3,
    y1: 434.62,
    x2: 573.3,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.69,
    y1: 434.62,
    x2: 579.69,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 586.08,
    y1: 441.84,
    x2: 586.08,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 586.08,
    y1: 434.62,
    x2: 586.08,
    y2: 439.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 592.46,
    y1: 434.62,
    x2: 592.46,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 598.85,
    y1: 434.62,
    x2: 598.85,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 605.24,
    y1: 435.03,
    x2: 605.24,
    y2: 445.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.62,
    y1: 441.2,
    x2: 611.62,
    y2: 445.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.62,
    y1: 435.03,
    x2: 611.62,
    y2: 436.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 618.01,
    y1: 435.03,
    x2: 618.01,
    y2: 445.31,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.4,
    y1: 435.03,
    x2: 624.4,
    y2: 445.31,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.78,
    y1: 435.03,
    x2: 630.78,
    y2: 445.31,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 637.17,
    y1: 443.23,
    x2: 637.17,
    y2: 445.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 637.17,
    y1: 435.03,
    x2: 637.17,
    y2: 439.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 643.56,
    y1: 435.03,
    x2: 643.56,
    y2: 445.31,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 649.94,
    y1: 435.03,
    x2: 649.94,
    y2: 445.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.25,
    y: 423.63,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.77,
    y: 423.63,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.67,
    y: 423.63,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.31,
    y: 423.63,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.69,
    y: 423.63,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 534.27,
    y1: 423.65,
    x2: 534.27,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.66,
    y1: 423.65,
    x2: 540.66,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.04,
    y1: 429.48,
    x2: 547.04,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.04,
    y1: 423.65,
    x2: 547.04,
    y2: 427.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 553.43,
    y1: 423.65,
    x2: 553.43,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 559.82,
    y1: 423.65,
    x2: 559.82,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.2,
    y1: 431.7,
    x2: 566.2,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.2,
    y1: 423.65,
    x2: 566.2,
    y2: 428.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 572.59,
    y1: 423.65,
    x2: 572.59,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 578.98,
    y1: 423.65,
    x2: 578.98,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 585.36,
    y1: 430.86,
    x2: 585.36,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 585.36,
    y1: 423.65,
    x2: 585.36,
    y2: 428.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.75,
    y1: 423.65,
    x2: 591.75,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 598.14,
    y1: 423.65,
    x2: 598.14,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 604.52,
    y1: 424.06,
    x2: 604.52,
    y2: 434.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 610.91,
    y1: 430.23,
    x2: 610.91,
    y2: 434.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 610.91,
    y1: 424.06,
    x2: 610.91,
    y2: 425.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 617.3,
    y1: 424.06,
    x2: 617.3,
    y2: 434.34,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 623.68,
    y1: 424.06,
    x2: 623.68,
    y2: 434.34,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.07,
    y1: 424.06,
    x2: 630.07,
    y2: 434.34,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 636.46,
    y1: 432.25,
    x2: 636.46,
    y2: 434.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 636.46,
    y1: 424.06,
    x2: 636.46,
    y2: 428.43,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 642.84,
    y1: 424.06,
    x2: 642.84,
    y2: 434.34,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 649.23,
    y1: 424.06,
    x2: 649.23,
    y2: 434.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.96,
    y: 412.65,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.49,
    y: 412.65,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.39,
    y: 412.65,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.03,
    y: 412.65,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.4,
    y: 412.65,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.98,
    y1: 412.67,
    x2: 537.98,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.37,
    y1: 412.67,
    x2: 544.37,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.76,
    y1: 418.5,
    x2: 550.76,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.76,
    y1: 412.67,
    x2: 550.76,
    y2: 416.56,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.14,
    y1: 412.67,
    x2: 557.14,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.53,
    y1: 412.67,
    x2: 563.53,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.92,
    y1: 420.73,
    x2: 569.92,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.92,
    y1: 412.67,
    x2: 569.92,
    y2: 417.39,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.3,
    y1: 412.67,
    x2: 576.3,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.69,
    y1: 412.67,
    x2: 582.69,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.08,
    y1: 419.89,
    x2: 589.08,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.08,
    y1: 412.67,
    x2: 589.08,
    y2: 417.39,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.46,
    y1: 412.67,
    x2: 595.46,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.85,
    y1: 412.67,
    x2: 601.85,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.24,
    y1: 413.08,
    x2: 608.24,
    y2: 423.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.62,
    y1: 419.25,
    x2: 614.62,
    y2: 423.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.62,
    y1: 413.08,
    x2: 614.62,
    y2: 414.88,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.01,
    y1: 413.08,
    x2: 621.01,
    y2: 423.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 627.4,
    y1: 413.08,
    x2: 627.4,
    y2: 423.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.78,
    y1: 413.08,
    x2: 633.78,
    y2: 423.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.17,
    y1: 421.28,
    x2: 640.17,
    y2: 423.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.17,
    y1: 413.08,
    x2: 640.17,
    y2: 417.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.56,
    y1: 413.08,
    x2: 646.56,
    y2: 423.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.94,
    y1: 413.08,
    x2: 652.94,
    y2: 423.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.87,
    y: 401.68,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.4,
    y: 401.68,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.29,
    y: 401.68,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.94,
    y: 401.68,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.31,
    y: 401.68,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.89,
    y1: 401.7,
    x2: 543.89,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.28,
    y1: 401.7,
    x2: 550.28,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.67,
    y1: 407.53,
    x2: 556.67,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.67,
    y1: 401.7,
    x2: 556.67,
    y2: 405.59,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.05,
    y1: 401.7,
    x2: 563.05,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.44,
    y1: 401.7,
    x2: 569.44,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.83,
    y1: 409.75,
    x2: 575.83,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.83,
    y1: 401.7,
    x2: 575.83,
    y2: 406.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.21,
    y1: 401.7,
    x2: 582.21,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.6,
    y1: 401.7,
    x2: 588.6,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.99,
    y1: 408.92,
    x2: 594.99,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.99,
    y1: 401.7,
    x2: 594.99,
    y2: 406.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.37,
    y1: 401.7,
    x2: 601.37,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.76,
    y1: 401.7,
    x2: 607.76,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.15,
    y1: 402.11,
    x2: 614.15,
    y2: 412.4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.53,
    y1: 408.28,
    x2: 620.53,
    y2: 412.4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.53,
    y1: 402.11,
    x2: 620.53,
    y2: 403.91,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.92,
    y1: 402.11,
    x2: 626.92,
    y2: 412.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.31,
    y1: 402.11,
    x2: 633.31,
    y2: 412.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.69,
    y1: 402.11,
    x2: 639.69,
    y2: 412.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.08,
    y1: 410.31,
    x2: 646.08,
    y2: 412.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.08,
    y1: 402.11,
    x2: 646.08,
    y2: 406.48,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.47,
    y1: 402.11,
    x2: 652.47,
    y2: 412.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 658.85,
    y1: 402.11,
    x2: 658.85,
    y2: 412.4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.59,
    y: 390.71,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.11,
    y: 390.71,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.01,
    y: 390.71,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.66,
    y: 390.71,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.03,
    y: 390.71,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.61,
    y1: 390.73,
    x2: 543.61,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 390.73,
    x2: 550,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.39,
    y1: 396.56,
    x2: 556.39,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.39,
    y1: 390.73,
    x2: 556.39,
    y2: 394.61,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.77,
    y1: 390.73,
    x2: 562.77,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.16,
    y1: 390.73,
    x2: 569.16,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.55,
    y1: 398.78,
    x2: 575.55,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.55,
    y1: 390.73,
    x2: 575.55,
    y2: 395.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 581.93,
    y1: 390.73,
    x2: 581.93,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.32,
    y1: 390.73,
    x2: 588.32,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.7,
    y1: 397.95,
    x2: 594.7,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.7,
    y1: 390.73,
    x2: 594.7,
    y2: 395.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.09,
    y1: 390.73,
    x2: 601.09,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.48,
    y1: 390.73,
    x2: 607.48,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 613.86,
    y1: 391.14,
    x2: 613.86,
    y2: 401.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.25,
    y1: 397.31,
    x2: 620.25,
    y2: 401.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.25,
    y1: 391.14,
    x2: 620.25,
    y2: 392.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.64,
    y1: 391.14,
    x2: 626.64,
    y2: 401.42,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.02,
    y1: 391.14,
    x2: 633.02,
    y2: 401.42,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.41,
    y1: 391.14,
    x2: 639.41,
    y2: 401.42,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.8,
    y1: 399.33,
    x2: 645.8,
    y2: 401.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.8,
    y1: 391.14,
    x2: 645.8,
    y2: 395.51,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.18,
    y1: 391.14,
    x2: 652.18,
    y2: 401.42,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 658.57,
    y1: 391.14,
    x2: 658.57,
    y2: 401.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.43,
    y: 379.73,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.96,
    y: 379.73,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.86,
    y: 379.73,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.5,
    y: 379.73,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.87,
    y: 379.73,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.46,
    y1: 379.75,
    x2: 544.46,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.84,
    y1: 379.75,
    x2: 550.84,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.23,
    y1: 385.59,
    x2: 557.23,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.23,
    y1: 379.75,
    x2: 557.23,
    y2: 383.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.62,
    y1: 379.75,
    x2: 563.62,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570,
    y1: 379.75,
    x2: 570,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.39,
    y1: 387.81,
    x2: 576.39,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.39,
    y1: 379.75,
    x2: 576.39,
    y2: 384.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.78,
    y1: 379.75,
    x2: 582.78,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.16,
    y1: 379.75,
    x2: 589.16,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.55,
    y1: 386.97,
    x2: 595.55,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.55,
    y1: 379.75,
    x2: 595.55,
    y2: 384.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.94,
    y1: 379.75,
    x2: 601.94,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.32,
    y1: 379.75,
    x2: 608.32,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.71,
    y1: 380.17,
    x2: 614.71,
    y2: 390.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.1,
    y1: 386.34,
    x2: 621.1,
    y2: 390.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.1,
    y1: 380.17,
    x2: 621.1,
    y2: 381.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 627.48,
    y1: 380.17,
    x2: 627.48,
    y2: 390.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.87,
    y1: 380.17,
    x2: 633.87,
    y2: 390.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.26,
    y1: 380.17,
    x2: 640.26,
    y2: 390.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.64,
    y1: 388.36,
    x2: 646.64,
    y2: 390.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.64,
    y1: 380.17,
    x2: 646.64,
    y2: 384.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.03,
    y1: 380.17,
    x2: 653.03,
    y2: 390.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 659.42,
    y1: 380.17,
    x2: 659.42,
    y2: 390.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.81,
    y: 368.76,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.33,
    y: 368.76,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.23,
    y: 368.76,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.87,
    y: 368.76,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.25,
    y: 368.76,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 538.83,
    y1: 368.78,
    x2: 538.83,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 545.22,
    y1: 368.78,
    x2: 545.22,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.6,
    y1: 374.61,
    x2: 551.6,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.6,
    y1: 368.78,
    x2: 551.6,
    y2: 372.67,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.99,
    y1: 368.78,
    x2: 557.99,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 564.38,
    y1: 368.78,
    x2: 564.38,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570.76,
    y1: 376.83,
    x2: 570.76,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570.76,
    y1: 368.78,
    x2: 570.76,
    y2: 373.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 577.15,
    y1: 368.78,
    x2: 577.15,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 583.54,
    y1: 368.78,
    x2: 583.54,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.92,
    y1: 376,
    x2: 589.92,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.92,
    y1: 368.78,
    x2: 589.92,
    y2: 373.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.31,
    y1: 368.78,
    x2: 596.31,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 602.7,
    y1: 368.78,
    x2: 602.7,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 609.08,
    y1: 369.19,
    x2: 609.08,
    y2: 379.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615.47,
    y1: 375.36,
    x2: 615.47,
    y2: 379.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615.47,
    y1: 369.19,
    x2: 615.47,
    y2: 370.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.85,
    y1: 369.19,
    x2: 621.85,
    y2: 379.48,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.24,
    y1: 369.19,
    x2: 628.24,
    y2: 379.48,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 634.63,
    y1: 369.19,
    x2: 634.63,
    y2: 379.48,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 641.01,
    y1: 377.39,
    x2: 641.01,
    y2: 379.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 641.01,
    y1: 369.19,
    x2: 641.01,
    y2: 373.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.4,
    y1: 369.19,
    x2: 647.4,
    y2: 379.48,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.79,
    y1: 369.19,
    x2: 653.79,
    y2: 379.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.53,
    y: 357.79,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.05,
    y: 357.79,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.95,
    y: 357.79,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.59,
    y: 357.79,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.97,
    y: 357.79,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 538.55,
    y1: 357.81,
    x2: 538.55,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.93,
    y1: 357.81,
    x2: 544.93,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.32,
    y1: 363.64,
    x2: 551.32,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.32,
    y1: 357.81,
    x2: 551.32,
    y2: 361.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.71,
    y1: 357.81,
    x2: 557.71,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 564.09,
    y1: 357.81,
    x2: 564.09,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570.48,
    y1: 365.86,
    x2: 570.48,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570.48,
    y1: 357.81,
    x2: 570.48,
    y2: 362.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.87,
    y1: 357.81,
    x2: 576.87,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 583.25,
    y1: 357.81,
    x2: 583.25,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.64,
    y1: 365.03,
    x2: 589.64,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.64,
    y1: 357.81,
    x2: 589.64,
    y2: 362.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.03,
    y1: 357.81,
    x2: 596.03,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 602.41,
    y1: 357.81,
    x2: 602.41,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.8,
    y1: 358.22,
    x2: 608.8,
    y2: 368.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615.19,
    y1: 364.39,
    x2: 615.19,
    y2: 368.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615.19,
    y1: 358.22,
    x2: 615.19,
    y2: 360.02,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.57,
    y1: 358.22,
    x2: 621.57,
    y2: 368.5,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 627.96,
    y1: 358.22,
    x2: 627.96,
    y2: 368.5,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 634.35,
    y1: 358.22,
    x2: 634.35,
    y2: 368.5,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.73,
    y1: 366.42,
    x2: 640.73,
    y2: 368.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.73,
    y1: 358.22,
    x2: 640.73,
    y2: 362.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.12,
    y1: 358.22,
    x2: 647.12,
    y2: 368.5,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.51,
    y1: 358.22,
    x2: 653.51,
    y2: 368.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.87,
    y: 346.82,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.4,
    y: 346.82,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.29,
    y: 346.82,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.94,
    y: 346.82,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.31,
    y: 346.82,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.89,
    y1: 346.84,
    x2: 543.89,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.28,
    y1: 346.84,
    x2: 550.28,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.67,
    y1: 352.67,
    x2: 556.67,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.67,
    y1: 346.84,
    x2: 556.67,
    y2: 350.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.05,
    y1: 346.84,
    x2: 563.05,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.44,
    y1: 346.84,
    x2: 569.44,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.83,
    y1: 354.89,
    x2: 575.83,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.83,
    y1: 346.84,
    x2: 575.83,
    y2: 351.56,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.21,
    y1: 346.84,
    x2: 582.21,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.6,
    y1: 346.84,
    x2: 588.6,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.99,
    y1: 354.05,
    x2: 594.99,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.99,
    y1: 346.84,
    x2: 594.99,
    y2: 351.56,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.37,
    y1: 346.84,
    x2: 601.37,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.76,
    y1: 346.84,
    x2: 607.76,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.15,
    y1: 347.25,
    x2: 614.15,
    y2: 357.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.53,
    y1: 353.42,
    x2: 620.53,
    y2: 357.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.53,
    y1: 347.25,
    x2: 620.53,
    y2: 349.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.92,
    y1: 347.25,
    x2: 626.92,
    y2: 357.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.31,
    y1: 347.25,
    x2: 633.31,
    y2: 357.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.69,
    y1: 347.25,
    x2: 639.69,
    y2: 357.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.08,
    y1: 355.44,
    x2: 646.08,
    y2: 357.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.08,
    y1: 347.25,
    x2: 646.08,
    y2: 351.62,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.47,
    y1: 347.25,
    x2: 652.47,
    y2: 357.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 658.85,
    y1: 347.25,
    x2: 658.85,
    y2: 357.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.96,
    y: 335.84,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.49,
    y: 335.84,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.39,
    y: 335.84,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.03,
    y: 335.84,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.4,
    y: 335.84,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.98,
    y1: 335.86,
    x2: 537.98,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.37,
    y1: 335.86,
    x2: 544.37,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.76,
    y1: 341.69,
    x2: 550.76,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.76,
    y1: 335.86,
    x2: 550.76,
    y2: 339.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.14,
    y1: 335.86,
    x2: 557.14,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.53,
    y1: 335.86,
    x2: 563.53,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.92,
    y1: 343.92,
    x2: 569.92,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.92,
    y1: 335.86,
    x2: 569.92,
    y2: 340.58,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.3,
    y1: 335.86,
    x2: 576.3,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.69,
    y1: 335.86,
    x2: 582.69,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.08,
    y1: 343.08,
    x2: 589.08,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.08,
    y1: 335.86,
    x2: 589.08,
    y2: 340.58,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.46,
    y1: 335.86,
    x2: 595.46,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.85,
    y1: 335.86,
    x2: 601.85,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.24,
    y1: 336.27,
    x2: 608.24,
    y2: 346.56,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.62,
    y1: 342.44,
    x2: 614.62,
    y2: 346.56,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.62,
    y1: 336.27,
    x2: 614.62,
    y2: 338.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.01,
    y1: 336.27,
    x2: 621.01,
    y2: 346.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 627.4,
    y1: 336.27,
    x2: 627.4,
    y2: 346.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.78,
    y1: 336.27,
    x2: 633.78,
    y2: 346.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.17,
    y1: 344.47,
    x2: 640.17,
    y2: 346.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.17,
    y1: 336.27,
    x2: 640.17,
    y2: 340.64,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.56,
    y1: 336.27,
    x2: 646.56,
    y2: 346.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.94,
    y1: 336.27,
    x2: 652.94,
    y2: 346.56,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.06,
    y: 324.87,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.58,
    y: 324.87,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.48,
    y: 324.87,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.12,
    y: 324.87,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.5,
    y: 324.87,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541.08,
    y1: 324.89,
    x2: 541.08,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.47,
    y1: 324.89,
    x2: 547.47,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 553.85,
    y1: 330.72,
    x2: 553.85,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 553.85,
    y1: 324.89,
    x2: 553.85,
    y2: 328.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560.24,
    y1: 324.89,
    x2: 560.24,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.63,
    y1: 324.89,
    x2: 566.63,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.01,
    y1: 332.94,
    x2: 573.01,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.01,
    y1: 324.89,
    x2: 573.01,
    y2: 329.61,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.4,
    y1: 324.89,
    x2: 579.4,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 585.79,
    y1: 324.89,
    x2: 585.79,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 592.17,
    y1: 332.11,
    x2: 592.17,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 592.17,
    y1: 324.89,
    x2: 592.17,
    y2: 329.61,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 598.56,
    y1: 324.89,
    x2: 598.56,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 604.95,
    y1: 324.89,
    x2: 604.95,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.33,
    y1: 325.3,
    x2: 611.33,
    y2: 335.59,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 617.72,
    y1: 331.47,
    x2: 617.72,
    y2: 335.59,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 617.72,
    y1: 325.3,
    x2: 617.72,
    y2: 327.1,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.11,
    y1: 325.3,
    x2: 624.11,
    y2: 335.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.49,
    y1: 325.3,
    x2: 630.49,
    y2: 335.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 636.88,
    y1: 325.3,
    x2: 636.88,
    y2: 335.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 643.27,
    y1: 333.5,
    x2: 643.27,
    y2: 336,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 643.27,
    y1: 325.3,
    x2: 643.27,
    y2: 329.67,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 649.65,
    y1: 325.3,
    x2: 649.65,
    y2: 335.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 656.04,
    y1: 325.3,
    x2: 656.04,
    y2: 335.59,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.31,
    y: 313.5,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.83,
    y: 313.5,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.73,
    y: 313.5,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.37,
    y: 313.5,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.75,
    y: 313.5,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.33,
    y1: 313.52,
    x2: 537.33,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.72,
    y1: 313.52,
    x2: 543.72,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.1,
    y1: 319.35,
    x2: 550.1,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.1,
    y1: 313.52,
    x2: 550.1,
    y2: 317.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.49,
    y1: 313.52,
    x2: 556.49,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.88,
    y1: 313.52,
    x2: 562.88,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.26,
    y1: 321.57,
    x2: 569.26,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.26,
    y1: 313.52,
    x2: 569.26,
    y2: 318.24,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.65,
    y1: 313.52,
    x2: 575.65,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.03,
    y1: 313.52,
    x2: 582.03,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.42,
    y1: 320.74,
    x2: 588.42,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.42,
    y1: 313.52,
    x2: 588.42,
    y2: 318.24,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.81,
    y1: 313.52,
    x2: 594.81,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.19,
    y1: 313.52,
    x2: 601.19,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.58,
    y1: 313.93,
    x2: 607.58,
    y2: 324.22,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 613.97,
    y1: 320.1,
    x2: 613.97,
    y2: 324.22,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 613.97,
    y1: 313.93,
    x2: 613.97,
    y2: 315.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.35,
    y1: 313.93,
    x2: 620.35,
    y2: 324.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.74,
    y1: 313.93,
    x2: 626.74,
    y2: 324.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.13,
    y1: 313.93,
    x2: 633.13,
    y2: 324.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.51,
    y1: 322.13,
    x2: 639.51,
    y2: 324.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.51,
    y1: 313.93,
    x2: 639.51,
    y2: 318.3,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.9,
    y1: 313.93,
    x2: 645.9,
    y2: 324.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.29,
    y1: 313.93,
    x2: 652.29,
    y2: 324.22,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.96,
    y: 302.53,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 579.48,
    y: 302.53,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.38,
    y: 302.53,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.03,
    y: 302.53,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.4,
    y: 302.53,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 534.98,
    y1: 302.55,
    x2: 534.98,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541.37,
    y1: 302.55,
    x2: 541.37,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.76,
    y1: 308.38,
    x2: 547.76,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.76,
    y1: 302.55,
    x2: 547.76,
    y2: 306.44,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 554.14,
    y1: 302.55,
    x2: 554.14,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560.53,
    y1: 302.55,
    x2: 560.53,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.92,
    y1: 310.6,
    x2: 566.92,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.92,
    y1: 302.55,
    x2: 566.92,
    y2: 307.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.3,
    y1: 302.55,
    x2: 573.3,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.69,
    y1: 302.55,
    x2: 579.69,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 586.08,
    y1: 309.77,
    x2: 586.08,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 586.08,
    y1: 302.55,
    x2: 586.08,
    y2: 307.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 592.46,
    y1: 302.55,
    x2: 592.46,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 598.85,
    y1: 302.55,
    x2: 598.85,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 605.24,
    y1: 302.96,
    x2: 605.24,
    y2: 313.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.62,
    y1: 309.13,
    x2: 611.62,
    y2: 313.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.62,
    y1: 302.96,
    x2: 611.62,
    y2: 304.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 618.01,
    y1: 302.96,
    x2: 618.01,
    y2: 313.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.4,
    y1: 302.96,
    x2: 624.4,
    y2: 313.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.78,
    y1: 302.96,
    x2: 630.78,
    y2: 313.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 637.17,
    y1: 311.16,
    x2: 637.17,
    y2: 313.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 637.17,
    y1: 302.96,
    x2: 637.17,
    y2: 307.33,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 643.56,
    y1: 302.96,
    x2: 643.56,
    y2: 313.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 649.94,
    y1: 302.96,
    x2: 649.94,
    y2: 313.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.25,
    y: 291.56,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.77,
    y: 291.56,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.67,
    y: 291.56,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.31,
    y: 291.56,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.69,
    y: 291.56,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 534.27,
    y1: 291.58,
    x2: 534.27,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.66,
    y1: 291.58,
    x2: 540.66,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.04,
    y1: 297.41,
    x2: 547.04,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 547.04,
    y1: 291.58,
    x2: 547.04,
    y2: 295.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 553.43,
    y1: 291.58,
    x2: 553.43,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 559.82,
    y1: 291.58,
    x2: 559.82,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.2,
    y1: 299.63,
    x2: 566.2,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566.2,
    y1: 291.58,
    x2: 566.2,
    y2: 296.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 572.59,
    y1: 291.58,
    x2: 572.59,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 578.98,
    y1: 291.58,
    x2: 578.98,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 585.36,
    y1: 298.8,
    x2: 585.36,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 585.36,
    y1: 291.58,
    x2: 585.36,
    y2: 296.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.75,
    y1: 291.58,
    x2: 591.75,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 598.14,
    y1: 291.58,
    x2: 598.14,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 604.52,
    y1: 291.99,
    x2: 604.52,
    y2: 302.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 610.91,
    y1: 298.16,
    x2: 610.91,
    y2: 302.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 610.91,
    y1: 291.99,
    x2: 610.91,
    y2: 293.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 617.3,
    y1: 291.99,
    x2: 617.3,
    y2: 302.27,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 623.68,
    y1: 291.99,
    x2: 623.68,
    y2: 302.27,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.07,
    y1: 291.99,
    x2: 630.07,
    y2: 302.27,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 636.46,
    y1: 300.18,
    x2: 636.46,
    y2: 302.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 636.46,
    y1: 291.99,
    x2: 636.46,
    y2: 296.36,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 642.84,
    y1: 291.99,
    x2: 642.84,
    y2: 302.27,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 649.23,
    y1: 291.99,
    x2: 649.23,
    y2: 302.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.96,
    y: 280.58,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.49,
    y: 280.58,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.39,
    y: 280.58,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.03,
    y: 280.58,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.4,
    y: 280.58,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.98,
    y1: 280.6,
    x2: 537.98,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.37,
    y1: 280.6,
    x2: 544.37,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.76,
    y1: 286.43,
    x2: 550.76,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.76,
    y1: 280.6,
    x2: 550.76,
    y2: 284.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.14,
    y1: 280.6,
    x2: 557.14,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.53,
    y1: 280.6,
    x2: 563.53,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.92,
    y1: 288.66,
    x2: 569.92,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.92,
    y1: 280.6,
    x2: 569.92,
    y2: 285.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.3,
    y1: 280.6,
    x2: 576.3,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.69,
    y1: 280.6,
    x2: 582.69,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.08,
    y1: 287.82,
    x2: 589.08,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.08,
    y1: 280.6,
    x2: 589.08,
    y2: 285.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.46,
    y1: 280.6,
    x2: 595.46,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.85,
    y1: 280.6,
    x2: 601.85,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.24,
    y1: 281.01,
    x2: 608.24,
    y2: 291.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.62,
    y1: 287.19,
    x2: 614.62,
    y2: 291.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.62,
    y1: 281.01,
    x2: 614.62,
    y2: 282.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.01,
    y1: 281.01,
    x2: 621.01,
    y2: 291.3,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 627.4,
    y1: 281.01,
    x2: 627.4,
    y2: 291.3,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.78,
    y1: 281.01,
    x2: 633.78,
    y2: 291.3,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.17,
    y1: 289.21,
    x2: 640.17,
    y2: 291.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.17,
    y1: 281.01,
    x2: 640.17,
    y2: 285.39,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.56,
    y1: 281.01,
    x2: 646.56,
    y2: 291.3,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.94,
    y1: 281.01,
    x2: 652.94,
    y2: 291.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.87,
    y: 269.61,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.4,
    y: 269.61,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.29,
    y: 269.61,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.94,
    y: 269.61,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.31,
    y: 269.61,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.89,
    y1: 269.63,
    x2: 543.89,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.28,
    y1: 269.63,
    x2: 550.28,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.67,
    y1: 275.46,
    x2: 556.67,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.67,
    y1: 269.63,
    x2: 556.67,
    y2: 273.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.05,
    y1: 269.63,
    x2: 563.05,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.44,
    y1: 269.63,
    x2: 569.44,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.83,
    y1: 277.68,
    x2: 575.83,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.83,
    y1: 269.63,
    x2: 575.83,
    y2: 274.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.21,
    y1: 269.63,
    x2: 582.21,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.6,
    y1: 269.63,
    x2: 588.6,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.99,
    y1: 276.85,
    x2: 594.99,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.99,
    y1: 269.63,
    x2: 594.99,
    y2: 274.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.37,
    y1: 269.63,
    x2: 601.37,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.76,
    y1: 269.63,
    x2: 607.76,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.15,
    y1: 270.04,
    x2: 614.15,
    y2: 280.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.53,
    y1: 276.21,
    x2: 620.53,
    y2: 280.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.53,
    y1: 270.04,
    x2: 620.53,
    y2: 271.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.92,
    y1: 270.04,
    x2: 626.92,
    y2: 280.33,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.31,
    y1: 270.04,
    x2: 633.31,
    y2: 280.33,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.69,
    y1: 270.04,
    x2: 639.69,
    y2: 280.33,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.08,
    y1: 278.24,
    x2: 646.08,
    y2: 280.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.08,
    y1: 270.04,
    x2: 646.08,
    y2: 274.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.47,
    y1: 270.04,
    x2: 652.47,
    y2: 280.33,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 658.85,
    y1: 270.04,
    x2: 658.85,
    y2: 280.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.59,
    y: 258.64,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.11,
    y: 258.64,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.01,
    y: 258.64,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.66,
    y: 258.64,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.03,
    y: 258.64,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 543.61,
    y1: 258.66,
    x2: 543.61,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 258.66,
    x2: 550,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.39,
    y1: 264.49,
    x2: 556.39,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.39,
    y1: 258.66,
    x2: 556.39,
    y2: 262.55,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.77,
    y1: 258.66,
    x2: 562.77,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.16,
    y1: 258.66,
    x2: 569.16,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.55,
    y1: 266.71,
    x2: 575.55,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.55,
    y1: 258.66,
    x2: 575.55,
    y2: 263.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 581.93,
    y1: 258.66,
    x2: 581.93,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.32,
    y1: 258.66,
    x2: 588.32,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.7,
    y1: 265.88,
    x2: 594.7,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.7,
    y1: 258.66,
    x2: 594.7,
    y2: 263.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.09,
    y1: 258.66,
    x2: 601.09,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.48,
    y1: 258.66,
    x2: 607.48,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 613.86,
    y1: 259.07,
    x2: 613.86,
    y2: 269.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.25,
    y1: 265.24,
    x2: 620.25,
    y2: 269.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.25,
    y1: 259.07,
    x2: 620.25,
    y2: 260.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 626.64,
    y1: 259.07,
    x2: 626.64,
    y2: 269.35,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.02,
    y1: 259.07,
    x2: 633.02,
    y2: 269.35,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.41,
    y1: 259.07,
    x2: 639.41,
    y2: 269.35,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.8,
    y1: 267.27,
    x2: 645.8,
    y2: 269.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.8,
    y1: 259.07,
    x2: 645.8,
    y2: 263.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.18,
    y1: 259.07,
    x2: 652.18,
    y2: 269.35,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 658.57,
    y1: 259.07,
    x2: 658.57,
    y2: 269.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.43,
    y: 247.67,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.96,
    y: 247.67,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.86,
    y: 247.67,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.5,
    y: 247.67,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.87,
    y: 247.67,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.46,
    y1: 247.69,
    x2: 544.46,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.84,
    y1: 247.69,
    x2: 550.84,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.23,
    y1: 253.52,
    x2: 557.23,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.23,
    y1: 247.69,
    x2: 557.23,
    y2: 251.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.62,
    y1: 247.69,
    x2: 563.62,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570,
    y1: 247.69,
    x2: 570,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.39,
    y1: 255.74,
    x2: 576.39,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.39,
    y1: 247.69,
    x2: 576.39,
    y2: 252.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 582.78,
    y1: 247.69,
    x2: 582.78,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.16,
    y1: 247.69,
    x2: 589.16,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.55,
    y1: 254.9,
    x2: 595.55,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.55,
    y1: 247.69,
    x2: 595.55,
    y2: 252.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 601.94,
    y1: 247.69,
    x2: 601.94,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.32,
    y1: 247.69,
    x2: 608.32,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.71,
    y1: 248.1,
    x2: 614.71,
    y2: 258.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.1,
    y1: 254.27,
    x2: 621.1,
    y2: 258.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.1,
    y1: 248.1,
    x2: 621.1,
    y2: 249.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 627.48,
    y1: 248.1,
    x2: 627.48,
    y2: 258.38,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 633.87,
    y1: 248.1,
    x2: 633.87,
    y2: 258.38,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.26,
    y1: 248.1,
    x2: 640.26,
    y2: 258.38,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.64,
    y1: 256.29,
    x2: 646.64,
    y2: 258.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 646.64,
    y1: 248.1,
    x2: 646.64,
    y2: 252.47,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.03,
    y1: 248.1,
    x2: 653.03,
    y2: 258.38,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 659.42,
    y1: 248.1,
    x2: 659.42,
    y2: 258.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.81,
    y: 236.69,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.33,
    y: 236.69,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.23,
    y: 236.69,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.87,
    y: 236.69,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.25,
    y: 236.69,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 538.83,
    y1: 236.71,
    x2: 538.83,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 545.22,
    y1: 236.71,
    x2: 545.22,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.6,
    y1: 242.54,
    x2: 551.6,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.6,
    y1: 236.71,
    x2: 551.6,
    y2: 240.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.99,
    y1: 236.71,
    x2: 557.99,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 564.38,
    y1: 236.71,
    x2: 564.38,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570.76,
    y1: 244.76,
    x2: 570.76,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570.76,
    y1: 236.71,
    x2: 570.76,
    y2: 241.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 577.15,
    y1: 236.71,
    x2: 577.15,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 583.54,
    y1: 236.71,
    x2: 583.54,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.92,
    y1: 243.93,
    x2: 589.92,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.92,
    y1: 236.71,
    x2: 589.92,
    y2: 241.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.31,
    y1: 236.71,
    x2: 596.31,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 602.7,
    y1: 236.71,
    x2: 602.7,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 609.08,
    y1: 237.12,
    x2: 609.08,
    y2: 247.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615.47,
    y1: 243.29,
    x2: 615.47,
    y2: 247.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615.47,
    y1: 237.12,
    x2: 615.47,
    y2: 238.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.85,
    y1: 237.12,
    x2: 621.85,
    y2: 247.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.24,
    y1: 237.12,
    x2: 628.24,
    y2: 247.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 634.63,
    y1: 237.12,
    x2: 634.63,
    y2: 247.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 641.01,
    y1: 245.32,
    x2: 641.01,
    y2: 247.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 641.01,
    y1: 237.12,
    x2: 641.01,
    y2: 241.49,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.4,
    y1: 237.12,
    x2: 647.4,
    y2: 247.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.79,
    y1: 237.12,
    x2: 653.79,
    y2: 247.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.53,
    y: 225.72,
    width: 129.27,
    height: 11.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.05,
    y: 225.72,
    width: 12.56,
    height: 11.46,
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.95,
    y: 225.72,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.59,
    y: 225.72,
    width: 28.85,
    height: 11.46,
    style: {
      fill: "#ababab",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.97,
    y: 225.72,
    width: 26.19,
    height: 11.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 538.55,
    y1: 225.74,
    x2: 538.55,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.93,
    y1: 225.74,
    x2: 544.93,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.32,
    y1: 231.57,
    x2: 551.32,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.32,
    y1: 225.74,
    x2: 551.32,
    y2: 229.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.71,
    y1: 225.74,
    x2: 557.71,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 564.09,
    y1: 225.74,
    x2: 564.09,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570.48,
    y1: 233.79,
    x2: 570.48,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 570.48,
    y1: 225.74,
    x2: 570.48,
    y2: 230.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 576.87,
    y1: 225.74,
    x2: 576.87,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 583.25,
    y1: 225.74,
    x2: 583.25,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.64,
    y1: 232.96,
    x2: 589.64,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 589.64,
    y1: 225.74,
    x2: 589.64,
    y2: 230.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.03,
    y1: 225.74,
    x2: 596.03,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 602.41,
    y1: 225.74,
    x2: 602.41,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.8,
    y1: 226.15,
    x2: 608.8,
    y2: 236.44,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615.19,
    y1: 232.32,
    x2: 615.19,
    y2: 236.44,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 615.19,
    y1: 226.15,
    x2: 615.19,
    y2: 227.95,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.57,
    y1: 226.15,
    x2: 621.57,
    y2: 236.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 627.96,
    y1: 226.15,
    x2: 627.96,
    y2: 236.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 634.35,
    y1: 226.15,
    x2: 634.35,
    y2: 236.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.73,
    y1: 234.35,
    x2: 640.73,
    y2: 236.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.73,
    y1: 226.15,
    x2: 640.73,
    y2: 230.52,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.12,
    y1: 226.15,
    x2: 647.12,
    y2: 236.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 653.51,
    y1: 226.15,
    x2: 653.51,
    y2: 236.44,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Banknotes--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.21,
    y: 75.86,
    width: 133.29,
    height: 230.76,
    transform: "matrix(1, 0.1, -0.1, 1, 21.15, -42.71)",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.47,114.59A16.08,16.08,0,0,1,487.07,97a17.81,17.81,0,0,1,.33-2l-76.15-7.6a19,19,0,0,1-.06,2,16.09,16.09,0,0,1-17.6,14.41c-.34,0-.66-.1-1-.15L376.24,267.75c.33,0,.66,0,1,.05a16.08,16.08,0,0,1,14.4,17.6,17.81,17.81,0,0,1-.33,2l76.15,7.6a19,19,0,0,1,.06-2,16.08,16.08,0,0,1,17.6-14.41,18.4,18.4,0,0,1,2,.33l16.38-164.24A15,15,0,0,1,501.47,114.59ZM437.23,217.47a26.36,26.36,0,1,1,28.85-23.61A26.36,26.36,0,0,1,437.23,217.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.31,
    y: 73.55,
    width: 133.29,
    height: 230.76,
    transform: "translate(53.91 -96.21) rotate(12.98)",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.8,120.71a16.08,16.08,0,0,1-12.06-19.28,15.08,15.08,0,0,1,.58-1.91L434.74,82.34a16.63,16.63,0,0,1-.31,2,16.08,16.08,0,0,1-19.28,12.06c-.33-.07-.64-.17-1-.27l-37,160.68c.33.05.66.09,1,.17a16.07,16.07,0,0,1,12.05,19.28,16.88,16.88,0,0,1-.57,1.91l74.57,17.18a15.24,15.24,0,0,1,.32-2,16.08,16.08,0,0,1,19.28-12.06,19.06,19.06,0,0,1,1.9.58L522.77,121A14.93,14.93,0,0,1,520.8,120.71ZM444,214.62a26.36,26.36,0,1,1,31.6-19.77A26.36,26.36,0,0,1,444,214.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.67,
    y: 83.04,
    width: 133.29,
    height: 230.76,
    transform: "translate(108.05 -159.09) rotate(22)",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544,142.15a16.1,16.1,0,0,1-8.89-20.94,18.49,18.49,0,0,1,.87-1.79L465,90.76a17.36,17.36,0,0,1-.62,1.89,16.09,16.09,0,0,1-20.94,8.89c-.31-.13-.6-.28-.9-.42L380.79,254c.32.11.63.2.94.33a16.07,16.07,0,0,1,8.89,20.93,14.82,14.82,0,0,1-.87,1.79l71,28.67a15,15,0,0,1,.62-1.9,16.07,16.07,0,0,1,20.93-8.88,14.82,14.82,0,0,1,1.79.87l61.83-153A16.84,16.84,0,0,1,544,142.15Zm-90.54,80.71a26.36,26.36,0,1,1,34.32-14.56A26.35,26.35,0,0,1,453.44,222.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.85,
    y: 101.33,
    width: 133.29,
    height: 230.76,
    transform: "translate(217.78 -240.25) rotate(35.83)",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.27,181.35a16.08,16.08,0,0,1-3.62-22.45,15.61,15.61,0,0,1,1.27-1.53l-62-44.8a14.83,14.83,0,0,1-1.05,1.69,16.07,16.07,0,0,1-22.45,3.63c-.28-.2-.52-.41-.78-.62L387.07,251c.28.18.57.35.84.54a16.08,16.08,0,0,1,3.62,22.45,15.74,15.74,0,0,1-1.27,1.54l62.05,44.79a16.82,16.82,0,0,1,1.05-1.69A16.08,16.08,0,0,1,475.81,315a15.74,15.74,0,0,1,1.54,1.27L574,182.41A16.93,16.93,0,0,1,572.27,181.35ZM465.06,238.08a26.36,26.36,0,1,1,36.8-5.94A26.36,26.36,0,0,1,465.06,238.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.34,
    y: 128.95,
    width: 133.29,
    height: 230.76,
    transform: "translate(392.66 -298.1) rotate(53.05)",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.11,237.73a16.09,16.09,0,0,1,3.18-22.52,15.91,15.91,0,0,1,1.67-1.09L552,153a19.06,19.06,0,0,1-1.51,1.3,16.09,16.09,0,0,1-22.52-3.18c-.2-.27-.37-.55-.56-.83L395.61,249.39c.22.25.44.49.64.76a16.09,16.09,0,0,1-3.18,22.52,15.91,15.91,0,0,1-1.67,1.09l46,61.15a17.19,17.19,0,0,1,1.51-1.3,16.08,16.08,0,0,1,22.52,3.18,17.69,17.69,0,0,1,1.09,1.67l131.89-99.23A17.28,17.28,0,0,1,593.11,237.73ZM473.92,260.18a26.36,26.36,0,1,1,36.91,5.22A26.35,26.35,0,0,1,473.92,260.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coins-1--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 456.26,
    cy: 343.57,
    r: 64.87,
    transform: "translate(-109.3 423.26) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.59,
    cy: 341.38,
    r: 64.87,
    transform: "translate(-109.13 419.31) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.59,
    cy: 341.38,
    r: 54.48,
    transform: "translate(5.19 689.53) rotate(-75.04)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.74,391l2-8.64q-9.48-2.59-12.89-9.45t-1.13-18.37l13.61.81a40.1,40.1,0,0,0-.82,8,9.87,9.87,0,0,0,1.3,5.19,5.72,5.72,0,0,0,3.73,2.48q2.88.68,4.38-.94a8.65,8.65,0,0,0,2.06-4,14.14,14.14,0,0,0-.35-8.44,34.52,34.52,0,0,0-4.49-7.85l-6.33-8.61a53.28,53.28,0,0,1-3.65-6.23,21.31,21.31,0,0,1-2-6.73,23.08,23.08,0,0,1,.57-8.18q2-8.75,8.12-12.46t14.61-2.44l1.92-8.27,4.46,1-1.92,8.27a17.58,17.58,0,0,1,7.7,4.18,14.11,14.11,0,0,1,3.72,6.14,24.17,24.17,0,0,1,.88,7.16,47.54,47.54,0,0,1-.67,7.14l-13.74-1.13a43.13,43.13,0,0,0,.85-6.21,9.18,9.18,0,0,0-.71-4.52,4.42,4.42,0,0,0-3.39-2.26,4.86,4.86,0,0,0-4.43,1.13,7.74,7.74,0,0,0-2.35,4.06,11.09,11.09,0,0,0,.45,7.34,44.72,44.72,0,0,0,3.48,6.09l6.16,8.48a52.7,52.7,0,0,1,4.27,7.35,29.28,29.28,0,0,1,2.52,8.17,24.91,24.91,0,0,1-.52,9.42,20.35,20.35,0,0,1-4.08,8.5,16.94,16.94,0,0,1-7.27,5.22,19.29,19.29,0,0,1-9.56.92l-2,8.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 548.33,
    cy: 394.14,
    r: 64.87,
    transform: "translate(-118.09 503.17) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.18,
    cy: 393.97,
    r: 64.87,
    transform: "translate(-119.48 499.47) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 543.18,
    cy: 393.97,
    r: 54.48,
    transform: "translate(-119.48 499.47) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.74,443.89l-1.56-8.73q-9.73,1.35-15.57-3.61t-8.26-16.45l12.83-4.62a39.12,39.12,0,0,0,2.39,7.67,9.81,9.81,0,0,0,3.23,4.26,5.79,5.79,0,0,0,4.41.81c1.93-.34,3.15-1.21,3.65-2.59a8.71,8.71,0,0,0,.31-4.51,14.21,14.21,0,0,0-3.64-7.63,34.42,34.42,0,0,0-7.22-5.44l-9.21-5.43a53.49,53.49,0,0,1-5.8-4.29,21.23,21.23,0,0,1-4.5-5.4,22.78,22.78,0,0,1-2.69-7.75q-1.59-8.82,2.56-14.65t12.47-8l-1.49-8.36,4.5-.8,1.5,8.35a17.71,17.71,0,0,1,8.72.82,14.17,14.17,0,0,1,5.83,4.19,23.85,23.85,0,0,1,3.63,6.23,48.45,48.45,0,0,1,2.19,6.82L548,379.16a44.29,44.29,0,0,0-1.66-6.05,9.22,9.22,0,0,0-2.44-3.87,4.39,4.39,0,0,0-4-.74,4.85,4.85,0,0,0-3.63,2.78,7.72,7.72,0,0,0-.57,4.65,11.12,11.12,0,0,0,3.31,6.58,43.65,43.65,0,0,0,5.6,4.23l9,5.37a53.31,53.31,0,0,1,6.81,5.08,28.93,28.93,0,0,1,5.53,6.52,24.94,24.94,0,0,1,3.23,8.86,20.5,20.5,0,0,1-.4,9.42,16.9,16.9,0,0,1-4.64,7.66,19.3,19.3,0,0,1-8.43,4.61l1.58,8.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.22,
    y: 50.65,
    width: 205.82,
    height: 399.08,
    rx: 19.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,78.07v-8a19.46,19.46,0,0,0-19.46-19.46H241.68a19.46,19.46,0,0,0-19.46,19.46v8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.12,59.28c0,2.44-2.74,3.32-2.75,5.18v.13H238v.82h-3.55v-.69c0-2.62,2.74-3.13,2.74-5.4,0-.84-.28-1.28-.95-1.28s-1,.48-1,1.19V60h-.84v-.66c0-1.23.57-2.06,1.82-2.06S238.12,58,238.12,59.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.55,59.27v.21a1.6,1.6,0,0,1-1,1.66,1.62,1.62,0,0,1,1,1.68v.62c0,1.24-.57,2-1.82,2s-1.82-.81-1.82-2v-.55h.84v.61c0,.73.31,1.17.95,1.17s1-.43,1-1.25V62.8c0-.8-.33-1.18-1-1.21h-.48v-.81h.53a1,1,0,0,0,1-1.11V59.3c0-.83-.29-1.26-1-1.26s-.95.45-.95,1.18v.42h-.84v-.37c0-1.24.58-2,1.82-2S242.55,58,242.55,59.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,59.88V61h-.87V59.88Zm0,4.41v1.12h-.87V64.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.13,60.61a1.3,1.3,0,0,1,1.2-.67c1,0,1.5.76,1.5,1.92v1.58c0,1.24-.59,2-1.82,2s-1.82-.81-1.82-2V62.9H246v.6c0,.73.3,1.17.94,1.17s1-.44,1-1.17V61.93c0-.73-.3-1.17-1-1.17a.88.88,0,0,0-.91.87v.18h-.84l.22-4.5h3.19v.81h-2.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,59.26v.15h-.84V59.2c0-.73-.3-1.16-1-1.16s-1,.44-1,1.31v1.82a1.3,1.3,0,0,1,1.3-.87c1,0,1.51.75,1.51,1.92v1.22c0,1.24-.62,2-1.85,2s-1.87-.81-1.87-2V59.32c0-1.29.58-2.09,1.87-2.09S253.33,58,253.33,59.26Zm-2.78,3V63.5c0,.73.3,1.17,1,1.17s1-.44,1-1.17V62.29c0-.73-.32-1.17-1-1.17S250.55,61.56,250.55,62.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.41,
    y: 59.61,
    width: 2.29,
    height: 5.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.46,
    y: 58.47,
    width: 2.29,
    height: 6.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.51,
    y: 57.66,
    width: 2.29,
    height: 7.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.56,
    y: 56.24,
    width: 2.29,
    height: 9.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.13,65.17H403.41V56.79h13.72Zm-12.95-.76h12.19V57.55H404.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.32,
    y: 58.38,
    width: 7.24,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.65,
    y: 59.99,
    width: 1.72,
    height: 1.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.39,63.35a.68.68,0,0,1-.27-.07c-2.79-1.66-4.63-.12-4.71-.06a.51.51,0,0,1-.72,0,.5.5,0,0,1,.05-.72c.1-.09,2.45-2.11,5.91-.05a.51.51,0,0,1,.18.7A.52.52,0,0,1,398.39,63.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.42,61.63a.5.5,0,0,1-.26-.08c-4-2.4-6.75-.07-6.78,0a.51.51,0,0,1-.68-.77s3.31-2.83,8-.06a.52.52,0,0,1-.26,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.35,59.63a.51.51,0,0,1-.26-.07c-5.11-3-8.51-.18-8.65-.05a.52.52,0,0,1-.72,0,.51.51,0,0,1,0-.72s4.07-3.49,9.85-.06a.52.52,0,0,1,.18.7A.53.53,0,0,1,400.35,59.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.84,64.21a1.29,1.29,0,0,1-2.57,0,1.29,1.29,0,1,1,2.57,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.57,64.84V77.1h3.81v34.83h-3.81v7.92h3.81v34.83h-3.81v7.92h3.81v34.84h-3.81v238.1a22.68,22.68,0,0,1-22.68,22.68H239.37a22.68,22.68,0,0,1-22.68-22.68V139.8H214V105h2.72V64.84a22.68,22.68,0,0,1,22.68-22.69H410.89A22.68,22.68,0,0,1,433.57,64.84Zm-59.31-14.2-6.69,10a10.81,10.81,0,0,1-9,4.78H291.67a10.81,10.81,0,0,1-9-4.78l-6.69-10H244.9a22.69,22.69,0,0,0-22.68,22.69V427.05a22.69,22.69,0,0,0,22.68,22.68H405.36A22.69,22.69,0,0,0,428,427.05V73.33a22.69,22.69,0,0,0-22.68-22.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.22,424.7v5.57a19.47,19.47,0,0,0,19.46,19.46h166.9A19.46,19.46,0,0,0,428,430.27V424.7Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.28,
    y: 231.48,
    width: 190.23,
    height: 8.93,
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.68,
    y: 367.98,
    width: 17.3,
    height: 51.58,
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.47,
    y: 379.32,
    width: 17.3,
    height: 40.24,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.26,
    y: 343.23,
    width: 17.3,
    height: 76.32,
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.04,
    y: 337.05,
    width: 17.3,
    height: 82.51,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.83,
    y: 324.67,
    width: 17.3,
    height: 94.88,
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.62,
    y: 320.21,
    width: 17.3,
    height: 99.35,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.41,
    y: 298.56,
    width: 17.3,
    height: 121,
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.19,
    y: 283.78,
    width: 17.3,
    height: 135.78,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "242 324.7 266.06 355.97 288.4 318.17 314.17 307.51 337.2 294.45 360.57 294.8 383.59 263.87 411.43 256.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.47,356a2.41,2.41,0,1,0-2.41,2.41A2.4,2.4,0,0,0,268.47,356Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8,318.51a2.41,2.41,0,1,0-2.4,2.41A2.39,2.39,0,0,0,290.8,318.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.58,307.51a2.41,2.41,0,1,0-2.41,2.41A2.41,2.41,0,0,0,316.58,307.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,294.46a2.41,2.41,0,1,0-2.4,2.4A2.4,2.4,0,0,0,339.6,294.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,294.8a2.41,2.41,0,1,0-2.4,2.4A2.4,2.4,0,0,0,363,294.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,263.87a2.41,2.41,0,1,0-2.41,2.4A2.41,2.41,0,0,0,386,263.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.84,256.31a2.41,2.41,0,1,0-2.41,2.4A2.41,2.41,0,0,0,413.84,256.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.41,324.7a2.41,2.41,0,1,0-2.41,2.4A2.41,2.41,0,0,0,244.41,324.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.58,159.46a39.17,39.17,0,0,0-25.14-30.55",
    style: {
      fill: "none",
      stroke: "#b5b5b5",
      strokeMiterlimit: 10,
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5,203.89a39.66,39.66,0,0,0,8.43.91,39.14,39.14,0,0,0,39.14-39.14,39.6,39.6,0,0,0-.49-6.2",
    style: {
      fill: "none",
      stroke: "#FF725E",
      strokeMiterlimit: 10,
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,128.91a39.15,39.15,0,1,0-21.94,75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.53,
    y1: 140.55,
    x2: 354.13,
    y2: 140.55,
    style: {
      fill: "none",
      stroke: "#b5b5b5",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.53,
    y1: 165.66,
    x2: 354.13,
    y2: 165.66,
    style: {
      fill: "none",
      stroke: "#FF725E",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.53,
    y1: 190.76,
    x2: 354.13,
    y2: 190.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.28,
    y1: 140.55,
    x2: 399.31,
    y2: 140.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.28,
    y1: 165.1,
    x2: 399.31,
    y2: 165.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.28,
    y1: 189.64,
    x2: 399.31,
    y2: 189.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.62,
    y1: 94.81,
    x2: 402.66,
    y2: 94.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271,
    y1: 94.81,
    x2: 331.81,
    y2: 94.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.65,
    y1: 94.81,
    x2: 267.66,
    y2: 94.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.52,
    y1: 104.85,
    x2: 402.66,
    y2: 104.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.46,
    y1: 104.85,
    x2: 358.59,
    y2: 104.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.65,
    y1: 104.85,
    x2: 292.76,
    y2: 104.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.42,
    y1: 114.89,
    x2: 402.66,
    y2: 114.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.27,
    y1: 114.89,
    x2: 311.17,
    y2: 114.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.65,
    y1: 114.89,
    x2: 248.69,
    y2: 114.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.38,
    y1: 248.78,
    x2: 334.04,
    y2: 248.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.47,
    y1: 248.78,
    x2: 292.84,
    y2: 248.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.65,
    y1: 248.78,
    x2: 255.52,
    y2: 248.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.6,
    y1: 258.82,
    x2: 334.04,
    y2: 258.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.02,
    y1: 258.82,
    x2: 308.41,
    y2: 258.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.65,
    y1: 258.82,
    x2: 270.12,
    y2: 258.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.05,
    y1: 268.86,
    x2: 334.04,
    y2: 268.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.73,
    y1: 268.86,
    x2: 280.83,
    y2: 268.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.65,
    y1: 268.86,
    x2: 244.49,
    y2: 268.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.88,435.12s-7,12.94-5.35,14.64,9.36,4.42,13,5.78,10,5.45,16.38,5.79,12.7-1.36,10.36-4.76-14.37-11.92-15.71-14-.34-6.46-.34-6.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9,452.82c-6.6-4.14-11.46-5.13-13.42-5.37-.26,1.11-.29,1.95,0,2.31,1.68,1.7,9.36,4.42,13,5.78s10,5.45,16.38,5.79,12.7-1.36,10.36-4.76C146.28,458.27,136.59,458.27,127.9,452.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,438.48s-2.14,20.76-.92,28.69S95.28,483,99.56,483.65s10.07-2.13,10.07-10.68-4.88-19.84-4.88-23.5-.62-9.77-.62-10.68S88.57,438.48,88.57,438.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.37,469.34c-.85,4.73-2.92,10.29-10.12,9.13-7.87-1.27-11.09-12.45-12-16.19a39.75,39.75,0,0,0,.35,4.89c1.22,7.94,7.63,15.87,11.91,16.48s10.07-2.13,10.07-10.68A28.58,28.58,0,0,0,109.37,469.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,282.51l10.07,87.3s-4.27,18.31-5.49,27.77S87,441.23,87,441.23s1.22,2.44,5.8,4,10.07,0,11.6-2.14a23.44,23.44,0,0,0,3.36-7.63c.3-1.83,19.23-56.77,20.14-61.35s1.22-13.74,1.22-15.26.61-45.48.61-45.48l23.51,51.58s-9.38,10.21-11.82,17.23-19.59,47.84-19.9,48.76-2.44,4.58-2.44,4.58a81.57,81.57,0,0,0,9.74,2.69,31.83,31.83,0,0,0,9.54,0s3.36-5,4.14-6.73c.46-1,39.17-58.5,40.08-61.55s1.22-5.19.92-10.38S163,281.9,163,279.76s-4.57-12.21-4.57-12.21-33.89,3.06-41.82,2.14-24.11-4.58-24.11-4.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,158.85l-7.68,6.74L115.5,274s9.41,6,22.88,2.83,16.14-5.8,16.14-5.8L152.8,165.28s-11.13-3.92-17.55-5.33A66.29,66.29,0,0,0,121,158.85Z",
    style: {
      fill: "#a6a6a6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75,197.18v94.5a104,104,0,0,0,12.41-1.46c7.48-1.28,9.49-4.2,9.49-4.2s-5.3-24.63-5.3-30.83.14-12.82.14-12.82,7,7.9,10.81,10.09,11.49,1.09,14.78-8.21-.18-18.25-2.74-23.36-8-24.81-9.3-31-1.83-13.87-4.56-17-16.61-7.84-18.25-8.57a45.54,45.54,0,0,0-5.29-1.64Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,155.54s7.48,3.51,8.39,7.89S163,198.09,163,198.09l-14.23-.91Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49,242.37s.73-22.23,3.9-39.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.06,238.24s-1.34,3.61,1.73,8.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,158.85s2.82,11.91,6.42,19.12,8.31,18.65,11.91,12.7,10-26.8,10-26.8-11.28,4.54-15.35,2.66S121,158.85,121,158.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.65,131.39c0,.6-.81,18.25-2,25.87s-7,13.48-8.2,14.48-6,1.56-10.64.55c-2.5-.55-5.76-3.27-8.48-6a71.5,71.5,0,0,1-4.95-5.46,7.92,7.92,0,0,1-1.13-3.05,46.6,46.6,0,0,1-.68-6.57l-1.4-.6c-1.41-.6-5.81-5.41-4.81-11.23s3.6-1.79,3.6-1.79,0-5.22,1.81-8.63,12.63-7.82,19.25-6.81S155.65,130.79,155.65,131.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.67,122.58a30.12,30.12,0,0,0-10.43-11.23s5.61-.8.2-6.41-27.86-3.61-32.67,1-9.22,8.22-7.62,13.63c0,0-3.61,4-2,8s5.82,10,5.82,10a11.51,11.51,0,0,0,1.2,2.41c.36.53,1,2,1.55,3.24l-.06.05s.16,11,.46,12.23a12.8,12.8,0,0,1,.13,2.27,7.92,7.92,0,0,0,1.13,3.05,70,70,0,0,0,4.73,5.23h0c2.77,2.77,6.14,5.63,8.71,6.19,4.61,1,9.44.45,10.64-.55a28.3,28.3,0,0,0,7.38-11.22,15.61,15.61,0,0,0-.75-4.64c-1-2.6-6.74.44-6.74.44s-.91,1.54-3.69,1.74-9.78-3.48-13-2.07c-1.7.74-2.3,3.43-2.49,5.84-.55-.27-1.41-1-2.69-3-1.74-2.66-2.16-9.55-2.25-13.71.16,0,.3-.26.4-.71.6-2.81,1.6-8.22,1.8-9.43a36.66,36.66,0,0,1,2.21-5.21s9.42,9.22,15,7.42,2-8.22,2-8.22,8.62,7.42,15,6.82S167.27,129.79,163.67,122.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.42,146.43s1,9.42-1,11.43-8.82-3.41-8.82-3.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.08,145.24s-4.89-3.15-8.8-.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.09,145.13s2.72-4,6.3-2.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.37,149.58a6.06,6.06,0,0,1,5.75.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.61,149.47s2.39-2.49,4.46-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.65,160.55s5.1,5.54,14.44.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,158.85l1.86,135.57s-5.66,1.09-16.79-2.38a85.78,85.78,0,0,1-20.43-9.85s0-12.09-2.31-21.85c-2.78-11.6-8-21.89-8.12-32.49-.18-19.52,4.77-44,4.77-44S115.3,160.3,121,158.85Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.11,155.54s-7.48,3.51-8.39,7.89-4.38,34.66-4.38,34.66l14.23-.91Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.57,
    y1: 257.69,
    x2: 98.69,
    y2: 207.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.16,
    y1: 223.25,
    x2: 102.04,
    y2: 211.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.9 233.85 68.31 228.55 70.78 234.03 63.9 233.85",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.54,195S55.89,206.66,57,208.12s9.85,19.16,9.85,19.16L69,237.13l12.77-2.92-2.74-8.94s2.56-3.1,2.56-5.29a23.37,23.37,0,0,0-.92-5.29s2.74-.91,3.1-3.1-2.18-9.67-3.1-10.58,0,.09-.91-.91a5.94,5.94,0,0,0-3.1-2c-.91-.18-2-.37-2-.37a3.76,3.76,0,0,0-2.37-2,12.61,12.61,0,0,0-3.47-.19S61.36,193.71,59.54,195Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.84,195.53s-8.61,8.25-8.61,9.41",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.68,197.72s-8.31,8.19-8.31,9.26",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.79,200.1s-7,7.24-7.2,8.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7,214.69l-1.26-3.8a3.74,3.74,0,0,0,1.51-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9,233.85l18-3.53,14.66,27.37a8.59,8.59,0,0,1,.71,7.07c-1.42,3.71-6.72,8.83-10.25,9.36s-9.36-2.65-11.83-4.42a15.93,15.93,0,0,1-4.06-4.06C70.78,265.11,63.9,233.85,63.9,233.85Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.61 195.63 174.97 198.03 170.74 238.24 188.52 235.7 192.61 195.63",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.46,212.56s-12,2.4-12.28,3.25.71,2.4,3.11,2.4,7.76-.42,9.45-1.41S195.29,213.13,193.46,212.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.46,206.36s-10.19,2.25-10.43,3,.6,2.25,2.64,2.25,6.59-.4,8-1.32S198,206.89,196.46,206.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33,217.64s-12,2.4-12.28,3.25.71,2.4,3.11,2.4,7.76-.43,9.45-1.41S194.16,218.21,192.33,217.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,223s-10,2-10.23,2.7.59,2,2.59,2,6.46-.36,7.87-1.18A2,2,0,0,0,193,223Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterRedesign);
export default __webpack_public_path__ + "static/media/master-redesign.0e7bc5fdbf8fd722f7b30b2e9750fa8d.svg";
export { ForwardRef as ReactComponent };